import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { PublicPasswordContext } from '../context/PublicPasswordContext';

const Header = () => {
    const publicPasswordContext = useContext(PublicPasswordContext);
    if (isMobile) {
        switch (publicPasswordContext.organizationData.positionOfLogo) {
            case 'left':
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col offset-0">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                        </div>
                    </div>
                );
            case 'center':
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col offset-1">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                        </div>
                    </div>
                );
            case 'right':
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col offset-4">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col offset-0">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                        </div>
                    </div>
                );
        }
    } else {
        switch (publicPasswordContext.organizationData.positionOfLogo) {
            case 'left':
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                            <div className="col"></div>
                            <div className="col"></div>
                        </div>
                    </div>
                );
            case 'center':
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col"></div>
                            <div className="col">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                            <div className="col"></div>
                        </div>
                    </div>
                );
            case 'right':
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col"></div>
                            <div className="col"></div>
                            <div className="col">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="container" style={publicPasswordContext.style.header}>
                        <div className="row">
                            <div className="col">
                                <img className="img-fluid logo" src={publicPasswordContext.organizationData.logo} alt="" />
                            </div>
                            <div className="col"></div>
                            <div className="col"></div>
                        </div>
                    </div>
                );
        }
    }
}

export default Header;